module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading.gif",
      "alt": "Now Loading...",
      "width": "80px",
      "height": "80px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1a3922c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 483
// module chunks = 1